import { type Breakpoint, type Theme, useMediaQuery, useTheme } from "@mui/material";

import { breakpoints as themeBreakpoints } from "../config/theme/breakpoints";

export function useWidth() {
  const theme = useTheme();
  const keys = theme.breakpoints.keys;

  const breakpoints = keys.map((key) => ({
    key,
    // eslint-disable-next-line react-hooks/rules-of-hooks
    query: useMediaQuery(theme.breakpoints.only(key)),
  }));

  return breakpoints.find(({ query }) => query)?.key || "xs";
}

export function widthUtils(theme: Theme) {
  const breakpoints = theme.breakpoints || themeBreakpoints;

  const { keys } = breakpoints;

  const isWidthDown = (breakpoint: Breakpoint, width: Breakpoint, inclusive = true) => {
    const breakpointIndex = keys.indexOf(breakpoint);
    const widthIndex = keys.indexOf(width);
    return inclusive ? breakpointIndex >= widthIndex : breakpointIndex > widthIndex;
  };

  const isWidthUp = (breakpoint: Breakpoint, width: Breakpoint, inclusive = true) => {
    const breakpointIndex = keys.indexOf(breakpoint);
    const widthIndex = keys.indexOf(width);
    return inclusive ? breakpointIndex <= widthIndex : breakpointIndex < widthIndex;
  };

  return { isWidthDown, isWidthUp };
}
